<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>

  import TnkcBanner from '../assets/tnkc-banner.png';

  export default {
    name: 'Crews',
    data() {
      return {
        tnkcBanner: TnkcBanner,
      };
    },
  };
</script>

<style scoped>
    #guestCrew .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        background-color: #b3dcfa;
    }
</style>